import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 默认跳转到收藏页
  { path: '/', redirect: '/dashboard' },

  // 登录注册
  {
    path: '/signin',
    component: () => import('@/views/SignIn.vue'),
    name: 'signin',
    meta: { hideNav: true }
  },

  // Collection 收藏
  {
    path: '/dashboard',
    component: () => import('@/views/Dashboard.vue'),
    name: 'dashboard',
    meta: { nav: 'collection' }
  },

  // 卡牌详情
  {
    path: '/card/:id',
    component: () => import('@/views/CardDetail.vue'),
    name: 'card-detail',
    meta: { hideNav: true }
  },

  // 扫描录入（需要登录）
  {
    path: '/scanner',
    component: () => import('@/views/Scanner.vue'),
    name: 'scanner',
    meta: { nav: 'scan', requiresAuth: true }
  },

  // Cards 卡牌表
  {
    path: '/cards',
    component: () => import('@/views/Database.vue'),
    name: 'cards',
    meta: { nav: 'cards' }
  },

  // 系列卡牌列表
  {
    path: '/cards/:setId',
    component: () => import('@/views/SetDetail.vue'),
    name: 'set-detail',
    meta: { hideNav: true }
  },

  // Profile 账户
  {
    path: '/profile',
    component: () => import('@/views/Profile.vue'),
    name: 'profile',
    meta: { nav: 'profile' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 动态获取登录状态（避免循环依赖，直接读 localStorage）
  const isLoggedIn = !!localStorage.getItem('opcardx_token')

  if (to.meta.requiresAuth && !isLoggedIn) {
    // 未登录访问需要登录的页面，跳转到登录页
    // 不传 redirect，登录后直接回首页
    next({ name: 'signin' })
  } else if (to.name === 'signin' && isLoggedIn) {
    // 已登录访问登录页，直接跳首页
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

// 捕获路由导航重定向/取消产生的 Promise rejection
// Vue Router 3 在导航守卫重定向时会抛出此错误，属正常行为无需处理
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) return err
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) return err
    return Promise.reject(err)
  })
}

export default router